import HadrianBase from '../hadrianBase';

export default class UserSettings extends HadrianBase {
  readonly metricMeasurementOn: boolean;
  readonly notificationsOn: boolean;
  readonly orderStatusNotificationsOn: boolean;
  readonly orderSummaryNotificationsOn: boolean;
  readonly quoteExpiryNotificationsOn: boolean;
  readonly quoteSentNotificationsOn: boolean;
  readonly invoiceNotificationsOn: boolean;
  readonly roomMeasurementToolNotificationsOn: boolean;
  readonly timeZoneId: string;
  readonly defaultBaseDepthStd: number;
  readonly defaultCustomDepthStd: number;
  readonly defaultBaseDepthAda: number;
  readonly defaultCustomDepthAda: number;
  readonly defaultDoorWidthStd: number;
  readonly defaultExtraDeepDepthAda: number;
  readonly adaDoorIsWallSide: boolean;
  readonly highDensityPanelsOn: boolean;
  readonly crossBracingOn: boolean;
  readonly paintedPostOn: boolean;
  readonly affOptionRespectingAdaStandardsEnabledForAdaAndAmbUnits: boolean;
}
